<template>
  <div class="paymentBox">
    <div class="paymentMask" @click="inPaymentType"></div>
    <div class="payment">
      <img
        alt="退出"
        class="paymentClose"
        src="../assets/img/web/common/close.png"
        @click="inPaymentType"
      />
      <div class="payment1 flexRow">
        <div class="paymentLeft flexColumn">
          <img alt="LOGO" src="../assets/img/web/common/LOGO.png" />
          <div v-for="tip in tips" :key="tip.title">
            <p>{{ tip.title }}：</p>
            <h1 v-for="itm in tip.list" :key="itm">{{ itm }}</h1>
          </div>
        </div>
        <div class="paymentRight flexColumn">
          <div class="paymentTop flexRow">
            <img
              :src="userData.figure1 ? userData.figure1 : head_img"
              alt="头像"
            />
            <div class="flexColumn">
              <p>
                用户账号：<span>{{ userData.nickName }}</span
                ><span style="color: #999999"
                  >（来自{{ userData.openIdType }}）</span
                >
              </p>
              <p class="conceal1">
                购买服务：<span style="color: #025df4">{{ title }}</span>
              </p>
            </div>
          </div>
          <div v-show="!WXQRCode" class="paymenBottom1 flexColumn">
            <div>
              <p>支付方式：</p>
              <div class="payWay flexRow">
                <div
                  v-for="(item, index) in payImg1"
                  :key="index"
                  :class="[
                    pay_way_select == index ? 'wayStyle2' : 'wayStyle1',
                    'way_zfb flexColumn'
                  ]"
                  @click="inPayWay(index)"
                >
                  <img :src="item" alt="支付logo" />
                </div>
              </div>
              <p>支付金额：</p>
              <h3>
                ￥<span>{{ price }}</span>
              </h3>
            </div>
            <div class="handPay flexRow">
              <div
                :class="[
                  select_clause ? 'payButton1' : 'payButton2',
                  'payButton'
                ]"
                @click="inPay"
              >
                立即支付
              </div>
              <label for="agreement" class="d-flex align-center">
                <input type="checkbox" v-model="select_clause" id="agreement">
                同意并接受<a
                  href="https://vip.foxitsoftware.cn/resources/vip_agreement.html"
                  target="_blank"
                  >《服务条款》</a
                >
              </label>
              <!-- <el-checkbox v-model="select_clause"
                >同意并接受<a
                  href="https://vip.foxitsoftware.cn/resources/vip_agreement.html"
                  target="_blank"
                  >《服务条款》</a
                >
              </el-checkbox> -->
            </div>
          </div>
          <div v-show="WXQRCode" class="paymentBottom2 flexColumn">
            <div class="payTop flexRow">
              <img :src="payImg2.img" alt="支付logo" />
              <div class="payTopVertical"></div>
              <span
                >￥<span>{{ price }}</span></span
              >
            </div>
            <div class="payCode flexRow">
              <img :src="WXQRCode" alt="二维码" />
            </div>
            <p>
              扫描二维码<span style="color: #999999">{{ payImg2.title }}</span>
            </p>
            <div v-show="payUnfinished" class="payUnfinished flexColumn">
              <h1>抱歉，您的付款尚未完成!</h1>
              <h2>订单号 {{ orderNum }} 请记下您的订单号，以便将来参考。</h2>
            </div>
            <div class="payReturn flexRow">
              <div class="payAgain" @click="$emit('reChoosePayWay')">
                重新选择支付方式
              </div>
              <div class="paidSucceed" @click="$emit('checkWxPay', 1)">
                付款完成
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "payLayer",
  props: {
    tips: {
      type: Array,
      required: true
    },
    userData: {
      type: Object,
      required: true
    },
    goodsDetails: {
      type: Object,
      required: true
    },
    orderNum: {
      type: String
    },
    payUnfinished: {
      // 是否支付完成
      type: Boolean,
      default: false
    },
    WXQRCode: {
      // 微信扫码支付的二维码
      type: String,
      default: ""
    }
  },
  data: () => ({
    nextPage: true, // 下一页
    pay_way_select: 0, // 0为微信，1为支付宝
    select_clause: true,
    // orderNum: "",
    head_img: require("../assets/img/web/common/moren.png"),
    codeImg: require("../assets/img/web/common/two_code.png"),

    // 第一页图片
    payImg1: [
      require("../assets/img/web/common/wx.png"),
      require("../assets/img/web/common/zfb.png")
    ],
    // 下一页图片
    payImg2: {
      img: require("../assets/img/web/common/wx2.png"),
      title: "（打开WeChat->发现->扫描二维码）"
    },
    // 详情数据
    title: "",
    price: "",
    id: ""
  }),
  mounted() {
    for (const x in this.goodsDetails) {
      this[x] = this.goodsDetails[x];
    }
  },
  methods: {
    // 弹窗
    inPaymentType() {
      this.$emit("closePayLayer");
    },
    inPay() {
      if (this.select_clause) {
        this.$emit("createPreVIPOrder", this.pay_way_select);
      }
    },
    // 选择支付方式
    inPayWay(e) {
      this.pay_way_select = e;
    }
  }
};
</script>

<style lang="scss" scoped>
.paymentBox {
  .paymentMask {
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(0, 0, 0, 0.4);
    z-index: 9999;
    top: 0;
    left: 0;
  }

  .payment {
    width: 800px;
    height: 620px;
    border-radius: 4px;
    position: fixed;
    background: #ffffff;
    z-index: 99999;
    top: 50%;
    left: 50%;
    margin-top: -310px;
    margin-left: -400px;

    .paymentClose {
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
    }

    .payment1 {
      width: 100%;
      height: 100%;
      border-radius: 4px;

      .paymentLeft {
        width: 180px;
        height: 620px;
        background: linear-gradient(#eef5ff, #bdd5fd);
        border-radius: 4px 0 0 4px;
        color: #666666;
        font-size: 12px;

        img {
          width: 88px;
          height: 58px;
          margin: 40px auto;
        }

        p {
          margin: 30px 0 20px 20px;
          font-weight: bold;
        }

        h1 {
          margin: 0 31px 0 28px;
          position: relative;
          + h1 {
            margin-top: 20px;
          }
        }

        h1:before {
          content: "·";
          color: #bbbbbb;
          font-size: 18px;
          line-height: 18px;
          position: absolute;
          left: -8px;
        }
      }

      .paymentRight {
        width: 620px;
        height: 620px;

        .paymentTop {
          width: 540px;
          height: 60px;
          padding: 40px;
          border-radius: 0 4px 0 0;
          background: #fafcff;
  
          img {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            margin-right: 20px;
          }

          div {
            justify-content: space-around;
            flex: 1;
            width: 0;
            p {
              color: #424242;
              font-size: 14px;
            }
          }
        }

        .paymenBottom1 {
          width: 540px;
          height: 420px;
          padding: 30px 40px;
          justify-content: space-between;

          p {
            margin-bottom: 20px;
            color: #999999;
            font-size: 14px;
          }

          .payWay {
            .way_wx,
            .way_zfb {
              width: 158px;
              height: 58px;
              border-radius: 4px;
              margin-right: 20px;
              margin-bottom: 40px;
              justify-content: center;
              align-items: center;
              cursor: pointer;

              img {
                width: 127px;
                height: 42px;
              }
            }

            .wayStyle1 {
              border: 1px solid #e8e8e8;
              background: rgba(0, 0, 0, 0);
            }

            .wayStyle2 {
              border: 1px solid #5793f8;
              background-image: url("../assets/img/web/common/xz.png");
              background-position: 100% 100%;
              background-repeat: no-repeat;
            }
          }

          h3 {
            color: #025df4;
            font-size: 24px;

            span {
              font-size: 40px;
              font-weight: bold;
            }
          }

          .handPay {
            align-items: center;
            color: #333333;

            .payButton {
              font-size: 14px;
              line-height: 40px;
              text-align: center;
              width: 100px;
              height: 40px;
              border-radius: 4px;
              margin-right: 20px;
            }

            .payButton1 {
              color: #ffffff;
              cursor: pointer;
              background: #025df4;
            }

            .payButton2 {
              color: #333333;
              cursor: not-allowed;
              background: #999999;
            }

            a {
              color: #1379f6;
            }
          }
        }

        .paymentBottom2 {
          width: 540px;
          height: 420px;
          padding: 30px 40px;
          align-items: center;

          .payTop {
            align-items: center;
            margin-bottom: 26px;

            img {
              width: 111px;
              height: 31px;
            }

            .payTopVertical {
              margin: auto 23px;
              width: 1px;
              height: 17px;
              background: #f2f2f2;
            }

            span {
              color: #025df4;
              font-size: 24px;
            }
          }

          .payCode {
            margin-bottom: 20px;

            img {
              width: 200px;
              height: 200px;
            }
          }

          p {
            font-size: 14px;
            color: #424242;
            margin-bottom: 20px;
          }

          .payUnfinished {
            margin-bottom: 20px;
            text-align: center;

            h1 {
              font-size: 16px;
              font-weight: bold;
              color: #f11010;
              margin: 10px 0;
            }

            h2 {
              font-size: 12px;
              color: #666666;
            }
          }

          .payReturn {
            .payAgain,
            .paidSucceed {
              margin: 0 5px;
              text-align: center;
              border-radius: 4px;
              font-size: 14px;
              cursor: pointer;
            }

            .payAgain {
              width: 154px;
              height: 38px;
              line-height: 38px;
              background: #ffffff;
              color: #666666;
              border: 1px solid #e0e0e0;
            }

            .paidSucceed {
              width: 100px;
              height: 40px;
              line-height: 40px;
              background: #025df4;
              color: #ffffff;
            }
          }
        }
      }
    }

    .payment2 {
      width: 100%;
      height: 100%;
      border-radius: 4px;
      background: red;
    }
  }
}
label{
  font-size: initial;
}
input{
  -moz-appearance: auto;
  appearance: auto;
  -webkit-appearance: auto;
  margin-right: 5px;
}
</style>
